import React from "react";
import { Tooltip } from "../../GeneralComponents/ui";
import i18n from "../../../Utils/i18next";
import { useDashboardContext } from "../DashboardContext";

const GenerateReportTrigger = ({ reportId, templateValid, children, innerClass }) => {
    const { openGenerateReport } = useDashboardContext();

    const tooltip = reportId ?
        templateValid === true ? "" : i18n.t("Designer.YouNeedToUploadTemplateFile") : i18n.t("Designer.ReportNotFound");

    const handleClick = (e) => {
        if (templateValid === true) {
            openGenerateReport(reportId, templateValid);
        }
    };

    return (
        <div className={innerClass || ""}>
            <Tooltip title={tooltip}>
                <div
                    className={templateValid === true ? "" : "disabled-btn"}
                    style={{ cursor: templateValid === true ? "pointer" : "not-allowed" }}
                >
                    {React.cloneElement(children, { onClick: handleClick })}
                </div>
            </Tooltip>
        </div>
    );
};

export default GenerateReportTrigger;
